import { StripeProductBoardFromJSON, StripeProductBoardToJSON, } from './StripeProductBoard';
/**
 * Check if a given object implements the CreateStripeProductBoardResponse interface.
 */
export function instanceOfCreateStripeProductBoardResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "createdProductBoard" in value;
    return isInstance;
}
export function CreateStripeProductBoardResponseFromJSON(json) {
    return CreateStripeProductBoardResponseFromJSONTyped(json, false);
}
export function CreateStripeProductBoardResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdProductBoard': StripeProductBoardFromJSON(json['createdProductBoard']),
    };
}
export function CreateStripeProductBoardResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdProductBoard': StripeProductBoardToJSON(value.createdProductBoard),
    };
}
